var map = {
	"./f_1.png": 375,
	"./f_2.png": 87,
	"./f_3.png": 901,
	"./f_4.png": 525,
	"./m_1.png": 873,
	"./m_2.png": 315,
	"./m_3.png": 583,
	"./m_4.png": 249,
	"./s_1.png": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;